module.exports = __webpack_public_path__ + "media/images/product_lines/travel/banner_bg-01c63b69edefe1d6f2ee1435222b49b7.svg";